// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5361":"css/app.6762","8959":"css/admin-app.6762"}[chunkId] + ".css";
};